import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  Form,
  Col,
  Modal,
  Row,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { getScoringByLoan } from "stores/Pengajuan/function";
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import Swal from "sweetalert2";
import { uploadSlikNasabah } from "stores/Pengajuan/function";
import { getAllPengajuan } from "stores/Pengajuan/function";
import DataTable from "react-data-table-component";

function Scoring() {
  const chartRef = useRef(null);
  const chartRef1 = useRef(null);
  const dispatch = useDispatch();
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const auth = useSelector((state) => state.authReducer);
  const valDetail = pengajuan.detailPengajuan;

  const listScoring = pengajuan.listScoring;
  // console.log(listScoring, "KKKK");

  const [pending, setPending] = React.useState(false);
  const [modalUploadSlik, setModalUploadSlik] = React.useState(false);
  const [pdfSlikNasabah, setPdfSlikNasabah] = React.useState("");
  const [filterStatus, setFilterStatus] = React.useState(null);
  const [page, setPage] = React.useState(0);
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [listLembagaKeuangan, setListLembagaKeuangan] = React.useState([]);
  const [selectedKategori, setSelectedKategori] = React.useState(null);
  const [modalKategoriVisible, setModalKategoriVisible] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;

  const formatRupiah = (angka) => {
    if (isNaN(angka) || angka === null || angka === undefined) {
      return "-"; // Tampilkan "-" jika nilai bukan angka
    }
    const numberFormat = new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    });
    return numberFormat.format(angka);
  };

  const handleKategoriClick = (Kategori) => {
    setSelectedKategori(Kategori);
    setModalKategoriVisible(true);
  };

  const handleModalClose = () => {
    setModalUploadSlik(false);
  };

  function submitUploadSlik(e) {
    e.preventDefault();
    if (pdfSlikNasabah === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Wajib di isi semua!",
      });
      return;
    }
    Swal.fire({
      title: "Konfirmasi",
      text: "Apakah Anda yakin ingin menyimpan perubahan ?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Ya",
      cancelButtonText: "Tidak",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Loading...",
          allowOutsideClick: false,
          showConfirmButton: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          },
        });
        let dataToSend = new FormData();
        dataToSend.append("loan", valDetail.id_pinjaman);
        dataToSend.append("dokumenSlik", pdfSlikNasabah);

        uploadSlikNasabah(dataToSend)
          .then((response) => {
            // console.log(response, "RESPON");
            if (response.data.status === 200) {
              Swal.close();
              Swal.fire({
                position: "center",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
              setModalUploadSlik(false);
              setPdfSlikNasabah("");
              getScoringByLoan(dispatch, {
                baploan: valDetail.id_pinjaman,
              });
              getAllPengajuan(dispatch, {
                status:
                  filterStatus === null || filterStatus.value === ""
                    ? ""
                    : filterStatus.value,
                cari: valDetail.id_pinjaman,
                page: page + 1,
                limit: totalPerHalaman,
              });
            } else if (response.data.status === 400) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response.data.message,
              });
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    });
  }

  React.useEffect(() => {
    let tmp =
      listScoring.data &&
      listScoring.data.map((val) => {
        return {
          ...val,
          action: <></>,
        };
      });
    setListLembagaKeuangan(tmp);
  }, [listScoring]);

  const KategoriModal = () => (
    <Modal
      show={modalKategoriVisible}
      onHide={() => setModalKategoriVisible(false)}
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Title
        style={{ textAlign: "center", fontWeight: "bolder", margin: 0 }}
      >
        Kategori Debitur
        <hr></hr>
      </Modal.Title>
      {/* <Modal.Body>{selectedKeterangan}</Modal.Body> */}
      <Card.Body>{selectedKategori}</Card.Body>
    </Modal>
  );

  const customStyles = {
    rows: {
      style: {
        height: "70px", // override the row height
      },
    },
    headRow: {
      style: {
        minHeight: 35,
        backgroundColor: "#F8F8F8",
        // fontFamily: "Poppins",
        justifyContent: "center",
      },
    },
    headCells: {
      style: {
        minHeight: 50,
        fontWeight: "bold",
        fontSize: 14,
        "&:first-child": {
          borderRight: "1px solid #ccc",
        },
      },
    },
    cells: {
      style: {
        minHeight: "70px",
        whiteSpace: "normal",
        wordBreak: "break-word",
        "&:first-child": {
          borderRight: "1px solid #ccc",
        },
      },
    },
  };

  const colLembagaKeuangan = [
    {
      name: "No",
      width: "100px",
      center: true,
      selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
    },
    {
      name: "No Rekening",
      minWidth: "230px",
      center: true,
      selector: (row) =>
        row[`Account Number`] === "" ? "-" : row[`Account Number`],
    },
    {
      name: "Cabang",
      minWidth: "250px",
      center: true,
      selector: (row) => (row.Branch === "" ? "-" : row.Branch),
      wrap: true,
    },
    {
      name: "Kondisi",
      minWidth: "250px",
      center: true,
      selector: (row) => (row.Condition === "" ? "-" : row.Condition),
    },
    {
      name: "Tanggal Kondisi",
      minWidth: "250px",
      center: true,
      selector: (row) =>
        row[`Condition Date`] === "" ? "-" : row[`Condition Date`],
    },
    {
      name: "Akad Kredit/Pembiayaan",
      minWidth: "250px",
      center: true,
      selector: (row) =>
        row[`Credit/Financing Contract`] === ""
          ? "-"
          : row[`Credit/Financing Contract`],
    },
    {
      name: "Plafon Awal",
      minWidth: "250px",
      center: true,
      selector: (row) =>
        row[`Initial Ceiling`] === "" ? "-" : row[`Initial Ceiling`],
    },
    {
      name: "Baki Debit",
      minWidth: "250px",
      center: true,
      selector: (row) =>
        row[`Debit Balance`] === "" ? "-" : row[`Debit Balance`],
    },
    {
      name: "Kualitas",
      minWidth: "250px",
      center: true,
      selector: (row) => (row[`Quality`] === "" ? "-" : row[`Quality`]),
    },
    {
      name: "Pelapor",
      minWidth: "290px",
      center: true,
      selector: (row) => (row.Reporter === "" ? "-" : row.Reporter),
      wrap: true,
    },
    {
      name: "Tunggakan Pokok",
      minWidth: "250px",
      center: true,
      selector: (row) =>
        row[`Principal Arrears`] === "" ? "-" : row[`Principal Arrears`],
    },
    {
      name: "Tunggakan Bunga",
      minWidth: "250px",
      center: true,
      selector: (row) =>
        row[`Interest Arrears`] === "" ? "-" : row[`Interest Arrears`],
    },
    {
      name: "Suku Bunga",
      minWidth: "250px",
      center: true,
      selector: (row) =>
        row[`Interest/Return Rate`] === "" ? "-" : row[`Interest/Return Rate`],
    },
    {
      name: "Jenis Suku Bunga/Imbalan",
      minWidth: "250px",
      center: true,
      selector: (row) =>
        row[`Interest/Return Type`] === "" ? "-" : row[`Interest/Return Type`],
    },
    {
      name: "Kategori Debitur",
      minWidth: "250px",
      center: true,
      selector: (row) =>
        row[`Debtor Category`] === "" ? "-" : row[`Debtor Category`],
      wrap: true,

      // cell: (row) => {
      //   const maxLength = 20;
      //   const kategori = row[`Debtor Category`] || "-";
      //   const isLongText = kategori.length > maxLength;
      //   const truncatedKeterangan = isLongText
      //     ? `${kategori.substring(0, maxLength)}...`
      //     : kategori;

      //   return (
      //     <>
      //       <div>{truncatedKeterangan}</div>
      //       {isLongText && (
      //         <div
      //           style={{ color: "blue", cursor: "pointer" }}
      //           onClick={() => handleKategoriClick(kategori)}
      //         >
      //           Selengkapnya
      //         </div>
      //       )}
      //     </>
      //   );
      // },
    },
  ];

  React.useEffect(() => {
    if (listScoring?.quality) {
      const root = am5.Root.new(chartRef.current);
      root.setThemes([am5themes_Animated.new(root)]);

      root._logo?.dispose();

      const chart = root.container.children.push(
        am5percent.PieChart.new(root, {
          layout: root.verticalLayout,
          endAngle: 270,
        })
      );

      const series = chart.series.push(
        am5percent.PieSeries.new(root, {
          valueField: "percentage",
          categoryField: "quality",
        })
      );

      series.data.setAll(listScoring.quality);

      series.slices.template.setAll({
        tooltipText: "{category}: {value}",
      });

      series.labels.template.setAll({
        text: "{category}: {value}%",
      });

      const legend = chart.children.push(
        am5.Legend.new(root, {
          centerX: am5.percent(50),
          x: am5.percent(50),
        })
      );

      legend.data.setAll(series.dataItems);

      legend.itemContainers.template.setAll({
        marginRight: 10,
        paddingTop: 10,
      });
      series.ticks.template.setAll({
        visible: true,
        strokeWidth: 5,
        stroke: am5.color(0x000000),
      });

      series.labels.template.setAll({
        fontSize: "13px", // Mengatur ukuran teks ticks
      });

      return () => {
        root.dispose();
      };
    }
  }, [pengajuan.listScoring]);

  React.useEffect(() => {
    if (listScoring?.report) {
      const root = am5.Root.new(chartRef1.current);
      root.setThemes([am5themes_Animated.new(root)]);

      root._logo?.dispose();

      const chart = root.container.children.push(
        am5percent.PieChart.new(root, {
          layout: root.verticalLayout,
          endAngle: 270,
        })
      );

      const series = chart.series.push(
        am5percent.PieSeries.new(root, {
          valueField: "percentage",
          categoryField: "reporter",
          //   endAngle: 270,
        })
      );

      series.data.setAll(listScoring.report);

      series.slices.template.setAll({
        tooltipText: "{category}: {value}",
      });

      series.labels.template.setAll({
        text: "{category}: {value}%",
      });

      const legend = chart.children.push(
        am5.Legend.new(root, {
          centerX: am5.percent(50),
          x: am5.percent(50),
        })
      );

      legend.data.setAll(series.dataItems);

      legend.itemContainers.template.setAll({
        marginRight: 10,
        paddingTop: 10,
      });
      series.ticks.template.setAll({
        visible: true,
        strokeWidth: 5,
        stroke: am5.color(0x000000),
      });

      series.labels.template.setAll({
        fontSize: "12px", // Mengatur ukuran teks ticks
      });

      return () => {
        root.dispose();
      };
    }
  }, [pengajuan.listScoring]);

  React.useEffect(() => {
    setPending(true);
    getScoringByLoan(dispatch, {
      baploan: valDetail.id_pinjaman,
    })
      .then(() => {
        setPending(false);
      })
      .catch((error) => {
        setPending(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [pengajuan.statusConvert, valDetail.id_pinjaman]);

  return (
    <>
      <Modal
        size="lg"
        show={modalUploadSlik}
        // onHide={() => setModalPenempatanSupervisor(!modalPenempatanSupervisor)}
        onHide={() => {
          handleModalClose();
          setModalUploadSlik(false);
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Col md="12" style={{ marginTop: 20 }}>
          <Card className="stacked-form" style={{ border: 0 }}>
            <Card.Header>
              <Card.Title
                as="h4"
                style={{
                  color: "black",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                Upload SLIK Nasabah
                <hr></hr>
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <Col sm="12">
                <Form.Group>
                  <li>
                    <label
                      style={{
                        fontWeight: "bold",
                        fontSize: 14,
                        color: "grey",
                        textTransform: "uppercase",
                      }}
                    >
                      Pilih File SLIK Nasabah
                    </label>
                  </li>
                  <Form.Control
                    type="file"
                    accept=".pdf"
                    onChange={(e) => {
                      setPdfSlikNasabah(e.target.files[0]);
                    }}
                  ></Form.Control>
                </Form.Group>
              </Col>
            </Card.Body>
            <Card.Footer>
              <Button
                className=" mr-0"
                style={{
                  backgroundColor: "#80AE62",
                  border: 0,
                  fontWeight: "bold",
                }}
                onClick={submitUploadSlik}
              >
                Submit
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      </Modal>

      <Col md="12" style={{ marginTop: 20 }}>
        {auth.role === "client" || auth.role === "super admin" ? (
          <div style={{ textAlign: "end" }}>
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>Upload SLIK</Tooltip>}
            >
              <Button
                className="mr-2"
                disabled={
                  valDetail.statusPengajuan !== "Diajukan" ||
                  listScoring.length !== 0
                }
                style={{
                  marginTop: 5,
                  backgroundColor: "#A2CFFE",
                  border: 0,
                  fontWeight: "bold",
                  color: "black",
                  cursor:
                    valDetail.statusPengajuan !== "Diajukan" ||
                    listScoring.length !== 0
                      ? "not-allowed"
                      : "pointer",
                }}
                onClick={() => {
                  // console.log(val, "KKKK");
                  setModalUploadSlik(!modalUploadSlik);
                }}
              >
                <i class="fas fa-file-upload"></i> Upload SLIK
              </Button>
            </OverlayTrigger>
          </div>
        ) : null}

        <Card.Header>
          <Card.Title
            as="h4"
            style={{
              fontWeight: "bold",
              textTransform: "uppercase",
              textAlign: "center",
            }}
            // onClick={() => {
            //   console.log(pengajuan.statusConvert);
            // }}
          >
            Hasil Analisa Slik
            <hr></hr>
          </Card.Title>
        </Card.Header>
        {!listScoring || listScoring.length === 0 ? (
          <div style={{ textAlign: "center" }}>
            <p
              style={{
                fontWeight: "bold",
                marginBottom: "1rem",
                color: "red",
              }}
            >
              Maaf, belum ada informasi scoring nasabah saat ini.
            </p>
            <img
              src={require("assets/img/sorry.jpg")}
              alt="Sorry"
              style={{
                maxWidth: "20%",
                display: "block",
                margin: "0 auto",
              }}
            />
          </div>
        ) : (
          <>
            <Card.Body>
              <Row
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <li style={{ fontWeight: "bolder" }}>
                  Total Baki:{" "}
                  {formatRupiah(
                    !listScoring ||
                      listScoring.length === 0 ||
                      !listScoring.totalBaki
                      ? "-"
                      : listScoring.totalBaki
                  )}
                </li>
                <li style={{ fontWeight: "bolder", textAlign: "center" }}>
                  Tunggakan Pokok:{" "}
                  {formatRupiah(
                    !listScoring ||
                      listScoring.length === 0 ||
                      !listScoring.tunggakanPokok
                      ? "-"
                      : listScoring.tunggakanPokok
                  )}
                </li>
                <li style={{ fontWeight: "bolder", textAlign: "right" }}>
                  Tunggakan Bunga:{" "}
                  {formatRupiah(
                    !listScoring ||
                      listScoring.length === 0 ||
                      !listScoring.tunggakkanBunga
                      ? "-"
                      : listScoring.tunggakkanBunga
                  )}
                </li>
              </Row>
              <hr></hr>
              <Row style={{ margin: 0, padding: 0 }}>
                <Col md="6">
                  <div>
                    <Card.Header>
                      <Card.Title
                        as="h3"
                        style={{
                          color: "black",
                          fontWeight: "bold",
                          textTransform: "uppercase",
                          textAlign: "center",
                        }}
                      >
                        Kolektibilitas
                        <hr></hr>
                      </Card.Title>
                    </Card.Header>
                  </div>
                  <div
                    ref={chartRef}
                    style={{ width: "100%", height: "400px" }}
                  />
                </Col>
                <Col md="6">
                  <div>
                    <Card.Header>
                      <Card.Title
                        as="h3"
                        style={{
                          color: "black",
                          fontWeight: "bold",
                          textTransform: "uppercase",
                          textAlign: "center",
                        }}
                      >
                        lambaga keuangan
                        <hr></hr>
                      </Card.Title>
                    </Card.Header>
                  </div>
                  <div
                    ref={chartRef1}
                    style={{ width: "100%", height: "480px" }}
                  />
                </Col>
              </Row>
            </Card.Body>
            <hr></hr>
            <Card style={{ border: 0 }}>
              <Card.Header>
                <Card.Title
                  as="h4"
                  style={{
                    fontWeight: "bold",
                    textTransform: "uppercase",
                    textAlign: "center",
                    marginBottom: 25,
                  }}
                  // onClick={() => {
                  //   console.log(pengajuan.statusConvert);
                  // }}
                >
                  Data SLIK Nasabah
                </Card.Title>
              </Card.Header>
              <div>
                <DataTable
                  columns={colLembagaKeuangan}
                  data={listLembagaKeuangan}
                  customStyles={customStyles}
                />
              </div>
            </Card>
            {modalKategoriVisible && <KategoriModal />}
          </>
        )}
      </Col>
    </>
  );
}

export default Scoring;
